<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-input
          v-model="getBusinessIntroduceList_data.businessName"
          placeholder="请输入产品介绍名"
          clearable
          size='small'
          style="max-width:200px;"/>
        <el-button
          v-click.getBusinessIntroduceList
          type="primary"
          icon='el-icon-search'
          size='small'
          style='margin-left:10px;'
        >搜索
        </el-button>
      </el-col>
      <el-col :span="6" >
        <el-button v-if="addBusinessIntroduce"
          @click=" $form('addBusinessIntroduce')"
          size='small'
          type="primary"
          style="float:right"
          icon='el-icon-circle-plus'
        >添加产品介绍
        </el-button>
      </el-col>
    </el-row>

    <mytable
      :tableColums='tableColums_getBusinessIntroduceList'
      api='getBusinessIntroduceList'
      xupdateapi='updateBusinessIntroduce'
      :height="H-165" >
       <icol slot='biCover' :showtooltip='false' img='biCover' />
       <icol slot='biPath' :showtooltip='false' img='biPath' />
    </mytable>

    <myform
      :viewobj='{
        addBusinessIntroduce:    [ "新增产品介绍信息", "el-icon-circle-plus" ],
        updateBusinessIntroduce: [ "修改产品介绍信息", "el-icon-edit-outline"],
        $succeed$: getBusinessIntroduceList
      }'
      @closed="
        $form('updateBusinessIntroduce','reset');
        window.sleep(50,v=>Myformdata&&(Myformdata.biCover=Myformdata.biCover=''))
      "
      @confirm='submitForm => $trigger("fileUpload").trigger(res=>res && submitForm())' 
      >
      <hide slot='biId' />
      <template v-slot:businessId="{Myformdata}" >
        <el-select v-model='Myformdata.businessId' clearable>
            <el-option
                v-for="item in getBusinessList_data.data||[]"
                :key="item.businessId"
                :label="item.businessName"
                :value="item.businessId">
            </el-option>
        </el-select>
  	  </template>
      <template v-slot:biDes="{Myformdata}" >
        <el-input :rows="3" v-model='Myformdata.biDes' type="textarea" placeholder="请输入产品描述"></el-input>
  	  </template>
      <template v-slot:biCover='{Myformdata}'  >
        <myupload
          v-event.fileUpload='`
            return (Myformdata.biCover+"").startsWith("http") 
              || ( (C = (await C.MyUpload()).file) ? Myformdata.biCover = C : false )
          `'
          @change='Myformdata.biCover=($file$=arguments[0]).url'
          @remove='window.sleep(150,v=>Myformdata.biCover="")'
          type='image'
          :limit='1'
          :params='{ file: "$file$" }'
          :filelist='
            Myformdata.biCover
            ? ( { name: Myformdata.name, url: Myformdata.biCover } )
            : false
          '
          :style="{height: Myformdata.biCover && $form('updateBusinessIntroduce','ifshow') ? '250px' : ''}"
         >
        </myupload>
      </template>
      <template v-slot:biVideoPath='{Myformdata}'  >
        <myupload
          v-event.fileUpload='`
            return (Myformdata.biVideoPath+"").startsWith("http") 
              || ( (C = (await C.MyUpload()).file) ? Myformdata.biVideoPath = C : false )
          `'
          @change='Myformdata.biVideoPath=($file$=arguments[0]).url'
          @remove='window.sleep(150,v=>Myformdata.biVideoPath="")'
          type='video'
          :limit='1'
          :require='false'
          :params='{ file: "$file$" }'
          :filelist='
            Myformdata.biVideoPath
            ? ( { name: Myformdata.name, url: Myformdata.biVideoPath } )
            : false
          '
          :style="{height: Myformdata.biVideoPath && $form('updateBusinessIntroduce','ifshow') ? '250px' : ''}"
         >
        </myupload>
      </template>
      <template v-slot:biPath='{Myformdata}'  >
        <myupload
          v-event.fileUpload='`
            return (Myformdata.biPath+"").startsWith("http") 
              || ( (C = (await C.MyUpload()).file) ? Myformdata.biPath = C : false )
          `'
          @change='Myformdata.biPath=($file$=arguments[0]).url'
          @remove='window.sleep(150,v=>Myformdata.biPath="")'
          type='image'
          :limit='1'
          :require='false'
          :params='{ file: "$file$" }'
          :filelist='
            Myformdata.biPath
            ? ( { name: Myformdata.name, url: Myformdata.biPath } )
            : false
          '
          :style="{height: Myformdata.biPath && $form('updateBusinessIntroduce','ifshow') ? '250px' : ''}"
         >
        </myupload>
      </template>

    </myform>
  </div>
</template>

<script>
export default {
  data() {
    return {
      biId: null,
      theMtId:"",

      tableColums_getBusinessIntroduceList: {
        $selection: false,


        businessName: '产品名称',
        biCover: '封面',
        biPath: '内容图片',
        biDes: '介绍',

        createtime: '创建时间',

        $operation: [
          '操作', 200,
          `@text: 播放#success
           @click: document.PreviewVideo($row.biVideoPath)
          `,
          this.updateBusinessIntroduce && `@text: 编辑#warn
           @click: $form("updateBusinessIntroduce",$row)
          `,
          this.deleteBusinessIntroduce && `@text: 删除#danger
           @click: _confirm('确定要删除该产品介绍吗?')
                   .trigger('deleteBusinessIntroduce',{biId:$row.biId})
                   .trigger('getBusinessIntroduceList')
          `,
        ],

      },

    };
  },

  watch: {
    
  },

  methods: {
  },

  created() {
    this.getBusinessIntroduceList({mtId:this.theMtId});
    this.getBusinessList({pageSize:0});
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/help/BusinessIntroduce.vue